import React from 'react'
import './style.css'

export default function DropDownButton({onClick, buttonList, text}) {
  return (
    <div className='DropDownButton'>
        <button onClick={onClick}>{text}</button>
        <div className='displayButtons'>
            {buttonList != null && buttonList}
        </div>
    </div>
  )
}
